import {
  OUTPATIENT_SEARCH, OUTPATIENT_SEARCH_SUCCESS, OUTPATIENT_SEARCH_FAILURE, OUTPATIENT_CLEAR,
  OUTPATIENT_SEARCH_AUTOCOMPLETE_SUCCESS, OUTPATIENT_AUTOCOMPLETE_CLEAR,
  OUTPATIENT_SEARCH_DETAIL, OUTPATIENT_SEARCH_DETAIL_FAILURE, OUTPATIENT_SEARCH_DETAIL_SUCCESS, OUTPATIENT_DETAIL_CLEAR,
  OUTPATIENT_EDIT, OUTPATIENT_EDIT_FAILURE, OUTPATIENT_EDIT_SUCCESS, OUTPATIENT_EDIT_CLEAR,
  OUTPATIENT_DELETE, OUTPATIENT_DELETE_FAILURE, OUTPATIENT_DELETE_SUCCESS,
  OUTPATIENT_MSG_ALERT,
  OUTPATIENT_SEARCH_PATIENT_CODE, OUTPATIENT_SEARCH_PATIENT_CODE_FAILURE, OUTPATIENT_SEARCH_PATIENT_CODE_SUCCESS
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    outpatient: null,
    outpatients: [],
    outpatientsAutocomplete: null,
    outpatientsNextPage: 1,
    outpatientsTotalCount: 0,
    outpatientsNextPageLink: null,
    outpatientsCurrentPage: null,
    searchParams: null,
    outpatientNotify: null,
    patientExist: null
  },
  getters: {
    outpatient: state => {
      return state.outpatient
    },
    outpatients: state => {
      return state.outpatients
    },
    patientExist: state => {
      return state.patientExist
    },
    outpatientsAutocomplete: state => {
      return state.outpatientsAutocomplete
    },
    outpatientsNextPage: state => {
      return state.outpatientsNextPage
    },
    outpatientsTotalCount: state => {
      return state.outpatientsTotalCount
    },
    outpatientsNextPageLink: state => {
      return state.outpatientsNextPageLink
    },
    outpatientsCurrentPage: state => {
      return state.outpatientsCurrentPage
    },
    outpatientsSearchParams: state => {
      return state.searchParams
    },
    /** 通知 */
    outpatientNotify: state => {
      return state.outpatientNotify
    }
  },
  actions: {
    [OUTPATIENT_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/outpatients'
      var loadparams = true
      var noneList = null
      var callback = () => {}
      if (params) {
        data = params.data
        state.searchParams = params.data

        if (params.autocomplete) {
          loadparams = false
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('noneList' in params) {
          noneList = params.noneList
        }
        if ('callback' in params) {
          callback = params.callback
        }
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.outpatients = null
          state.outpatientsNextPage = 0
          state.outpatientsTotalCount = 0
          state.outpatientsNextPageLink = null
          state.outpatientsCurrentPage = null
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(OUTPATIENT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            if (params.autocomplete) {
              commit(OUTPATIENT_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, noneList: noneList, callback: callback})
            } else {
              commit(OUTPATIENT_SEARCH_SUCCESS, {data: res.data, callback: callback})
            }
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [OUTPATIENT_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(OUTPATIENT_CLEAR)
      }, sleep)
    },
    [OUTPATIENT_DETAIL_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(OUTPATIENT_DETAIL_CLEAR)
      }, sleep)
    },
    [OUTPATIENT_EDIT_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(OUTPATIENT_EDIT_CLEAR)
      }, sleep)
    },
    [OUTPATIENT_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(OUTPATIENT_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },
    [OUTPATIENT_SEARCH_DETAIL]  ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback

      dispatch('apiGet', {url: '/outpatients/' + params.outpatientId, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(OUTPATIENT_SEARCH_DETAIL_FAILURE, res.data)
          } else {
            commit(OUTPATIENT_SEARCH_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [OUTPATIENT_SEARCH_PATIENT_CODE] ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiGet', { url: '/outpatients/search_patient_code', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(OUTPATIENT_SEARCH_PATIENT_CODE_FAILURE, res.data)
          } else {
            commit(OUTPATIENT_SEARCH_PATIENT_CODE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [OUTPATIENT_EDIT]  ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiPost', {url: '/outpatients', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(OUTPATIENT_EDIT_FAILURE, res.data)
          } else {
            commit(OUTPATIENT_EDIT_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [OUTPATIENT_DELETE]  ({dispatch, state, commit}, params) {
      var callback = params.callback
      dispatch('apiDelete', {url: '/outpatients/' + params.outpatientId})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(OUTPATIENT_DELETE_FAILURE, res.data)
          } else {
            commit(OUTPATIENT_DELETE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [OUTPATIENT_MSG_ALERT] ({state, commit}, msg) {
      commit(OUTPATIENT_MSG_ALERT, msg)
    }
  },
  mutations: {
    [OUTPATIENT_SEARCH_FAILURE] (state, data) {
      console.log('OUTPATIENT_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [OUTPATIENT_SEARCH_SUCCESS] (state, params) {
      console.log('OUTPATIENT_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      state.outpatientsTotalCount = 0

      if (reSearch) {
        // 再検索
        state.outpatients = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.outpatientsNextPage = null
        }
      } else {
        if (data.meta) {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.outpatients = state.outpatients.concat(data.data)
            state.outpatientsCurrentPage = data.meta['current-page']
          } else {
            state.outpatients = data.data
            state.outpatientsCurrentPage = data.meta['current-page']
          }
          state.outpatientsNextPage = null
          if (data.meta['next-page']) {
            state.outpatientsNextPage = data.meta['next-page']
          }
        } else {
          state.outpatients = data.data
        }
        state.outpatientsNextPageLink = null
        if (data.links && data.links['next']) {
          state.outpatientsNextPageLink = data.links['next']
        } else {
          state.outpatientsNextPageLink = null
        }
      }

      if (data.meta && data.meta['total-count']) {
        state.outpatientsTotalCount = data.meta['total-count']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [OUTPATIENT_CLEAR] (state) {
      state.outpatients = []
    },
    [OUTPATIENT_DETAIL_CLEAR] (state) {
      state.outpatients = null
    },
    [OUTPATIENT_EDIT_CLEAR] (state) {
      state.outpatient = null
    },
    [OUTPATIENT_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('OUTPATIENT_SEARCH_AUTOCOMPLETE_SUCCESS')
      var data = param.data.data
      state.outpatientsAutocomplete = data
      // なし追加
      if (param.noneList !== null) {
        if (state.outpatientsAutocomplete === null) {
          state.outpatientsAutocomplete = []
        }
        state.outpatientsAutocomplete.unshift({
          'id': param.noneList['id'],
          'type': 'outpatients',
          'attributes': {
            'outpatient-name': param.noneList['name'],
            'outpatient-name-furigana': '',
            'email': ''
          }
        })
      }
    },
    [OUTPATIENT_AUTOCOMPLETE_CLEAR] (state) {
      console.log('OUTPATIENT_AUTOCOMPLETE_CLEAR')
      state.outpatientsAutocomplete = null
    },
    [OUTPATIENT_SEARCH_DETAIL_FAILURE] (state, data) {
      console.log('OUTPATIENT_SEARCH_DETAIL_FAILURE')
    },
    [OUTPATIENT_SEARCH_DETAIL_SUCCESS] (state, params) {
      console.log('OUTPATIENT_SEARCH_DETAIL_SUCCESS')
      state.outpatient = params.data.data[0]
      if (params.callback) {
        params.callback(params.data.data)
      }
    },
    [OUTPATIENT_SEARCH_PATIENT_CODE_FAILURE] (state, params) {
      // 通知
      state.outpatientNotify = {
        danger: true,
        message_i18n: 'Outpatient.denger'
      }
      setTimeout(() => {
        state.outpatientNotify = null
        state.patientExist = true
      }, constant.notifyShowTime.normal)
      console.log('OUTPATIENT_SEARCH_PATIENT_CODE_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [OUTPATIENT_SEARCH_PATIENT_CODE_SUCCESS] (state, params) {
      console.log('OUTPATIENT_SEARCH_PATIENT_CODE_SUCCESS')
      state.patientExist = false
      if (params.callback) {
        params.callback()
      }
    },
    [OUTPATIENT_EDIT_FAILURE] (state, data) {
      console.log('OUTPATIENT_EDIT_FAILURE')
      // 通知
      state.outpatientNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.outpatientNotify = null
      }, constant.notifyShowTime.normal)
    },
    [OUTPATIENT_EDIT_SUCCESS] (state, params) {
      console.log('OUTPATIENT_EDIT_SUCCESS')
      state.outpatient = params.data.data
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.outpatientNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.outpatientNotify = null
      }, constant.notifyShowTime.normal)
    },
    [OUTPATIENT_DELETE_FAILURE] (state, data) {
      console.log('OUTPATIENT_DELETE_FAILURE')
      // 通知
      state.outpatientNotify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.outpatientNotify = null
      }, constant.notifyShowTime.normal)
    },
    [OUTPATIENT_DELETE_SUCCESS] (state, params) {
      console.log('OUTPATIENT_DELETE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.outpatientNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.outpatientNotify = null
      }, constant.notifyShowTime.normal)
    },
    [OUTPATIENT_MSG_ALERT] (state, msg) {
      state.outpatientNotify = msg
      setTimeout(() => { state.outpatientNotify = null }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/outpatient.js